import { useState } from "react";

import axios from "axios";
import sockets from "../../../../socket/socket";

const socket = sockets;

export default function DeeletNotifybtn(item,index) {
const [loading,setLoading]= useState(false)
    
    const handleDelete = (e) => {
       
        setLoading(true)
        axios
          .post("/handleDelete/api", {
            itemID: item.item._id,
          })
          .then(function (response) {
            console.log(response);
            socket.emit("getNotifyEmit");
            setLoading(false)
          })
          .catch(function (error) {
            console.log(error);
            setLoading(false)
          });
      };

      if (loading) {
        return <div class="custom-loader-deleteNotify"></div>

      }
  //   return  <span key={index}
  //   className="material-symbols-outlined"
  //   onClick={handleDelete}
  // >
  //   delete_forever
  // </span>
 return <svg xmlns="http://www.w3.org/2000/svg" width="30" height="29" viewBox="0 0 30 29" fill="none" onClick={handleDelete}>
  <circle cx="14.8999" cy="14.5" r="14.5" fill="#F5F5F5"/>
  <path d="M8.89077 22.2333C8.45122 22.2333 8.07494 22.1071 7.76193 21.8546C7.44891 21.6023 7.29241 21.2988 7.29241 20.9444V8.69994H6.2002V7.41105H11.2084V6.7666H18.2412V7.41105H23.2494V8.69994H22.1572V20.9444C22.1572 21.2881 21.9973 21.5889 21.6777 21.8466C21.358 22.1045 20.985 22.2333 20.5587 22.2333H8.89077ZM20.5587 8.69994H8.89077V20.9444H20.5587V8.69994ZM11.7145 19.097H13.3129V10.5259H11.7145V19.097ZM16.1367 19.097H17.7351V10.5259H16.1367V19.097Z" fill="#E62E7B"/>
</svg>


  
}